export default class ChannelDto {
    constructor({
        type = '',
        action = () => {},
    }) {
        this.type = type
        this.action = action
    }
}
